
import React from 'react'
import { useSelector } from 'react-redux';

const H3 = ({ whiteThemeColor, darkThemeColor, children }) => {

    const fontSizeMultiplier = useSelector((state) => state.fontSizeMultiplier.fontSize);
    const darkWhiteThemeToggle = useSelector((state) => state.darkWhiteThemeToggle.theme);

    return (
        <h3 style={{ fontSize: `${16 * fontSizeMultiplier / 100}px`, color: `${darkWhiteThemeToggle === "WHITE" ? whiteThemeColor = "#8887C9" : darkThemeColor = "#fff"}` }}>{children}</h3>
    )
}

export default H3